/**
 * Seller intake attribution context for API payloads (Sell Your Car M5).
 */
import { readUtmParams } from "../../clientViewRuntime/utils/session";
import {
  SELLER_SOURCE_ACTIONS,
  SELLER_SOURCE_COMPONENTS,
  SELLER_SOURCE_PAGES,
} from "./sellerIntakeConstants";

/**
 * @param {{
 *   sourceComponent?: string,
 *   sourceAction?: string,
 *   currentPath?: string,
 * }} [options]
 * @returns {import('./sellerIntakeTypes').SellerAttributionContext}
 */
export function buildSellerSubmissionAttribution(options = {}) {
  const {
    sourceComponent = SELLER_SOURCE_COMPONENTS.SELL_YOUR_CAR_FORM,
    sourceAction = SELLER_SOURCE_ACTIONS.SELLER_SUBMISSION_ATTEMPTED,
    currentPath = "/vender-mi-carro",
  } = options;

  if (typeof window === "undefined") {
    return {
      sourcePage: SELLER_SOURCE_PAGES.SELL_YOUR_CAR,
      sourceComponent,
      sourceAction,
      currentPath,
      referrer: null,
      utmSource: null,
      utmMedium: null,
      utmCampaign: null,
      utmContent: null,
      utmTerm: null,
    };
  }

  const utm = readUtmParams(new URLSearchParams(window.location.search));

  return {
    sourcePage: SELLER_SOURCE_PAGES.SELL_YOUR_CAR,
    sourceComponent,
    sourceAction,
    currentPath: window.location.pathname || currentPath,
    referrer: document.referrer || null,
    utmSource: utm.source || null,
    utmMedium: utm.medium || null,
    utmCampaign: utm.campaign || null,
    utmContent: utm.content || null,
    utmTerm: utm.term || null,
  };
}
